﻿import { accordionCollapsible } from './accordion-collapsible';
import { offersCollapsible } from './offers-collapsible';

export const specialOffersFiltersDropdown = function (dropdown, onFilterTicked) {

    const activeAttribute = "active";
    const stickyAttribute = "sticky";
    let stickyHeight = 0;
    const scrollDisabledAttribute = "scroll-disable";
    const navHeader = document.querySelector('.zen-nav-header');
    const navHeaderMobile = document.querySelector('.zen-nav-header-mobile');
    const heroModule = document.querySelector('.hero-module');
    const filtersButtonContainer = document.querySelector('.row--top');
    const filtersContent = document.querySelector('.filters__content');
    const showResultsButton = document.querySelector('.filters__content .bottom-panel .button');
    const accordions = document.getElementsByClassName('z-accordion');
    const filterCheckboxes = document.getElementsByClassName('checkbox__input');
    const filters = document.getElementsByClassName('checkbox-list__item');

    const showResults = () => {
        close();
        scroll();
        filtersContent.removeAttribute(activeAttribute);
        toggleCollasibleFilters(false);
    }

    //16 is the padding between hero module and the filters
    const setStickyHeight = () => {
        stickyHeight = heroModule.getBoundingClientRect().bottom - document.body.getBoundingClientRect().top + 16;
    }

    const scroll = () => {
        let y = window.scrollY;
        if (y >= stickyHeight) {
            filtersButtonContainer.setAttribute(stickyAttribute, '');
        } else {
            filtersButtonContainer.removeAttribute(stickyAttribute);
        }
    }

    function onCollapsibleToggled(e) {
        toggleCollasibleFilters(e.isOpen);
    }

    function toggleCollasibleFilters(isOpen) {
        if (isOpen) {
            navHeader.hidden = true;
            navHeaderMobile.hidden = true;
            filtersContent.setAttribute(activeAttribute, '');
            filtersButtonContainer.setAttribute(stickyAttribute, '');
            document.body.setAttribute(scrollDisabledAttribute, '')
            window.removeEventListener('scroll', scroll);
        } else {
            navHeader.hidden = false;
            navHeaderMobile.hidden = false;
            let y = window.scrollY;
            filtersContent.removeAttribute(activeAttribute);
            if (y < stickyHeight) {
                filtersButtonContainer.removeAttribute(stickyAttribute);
            }
            document.body.removeAttribute(scrollDisabledAttribute)
            window.addEventListener('scroll', scroll);
        }

        const liveChat = document.getElementById('Microsoft_Omnichannel_LCWidget_Chat_Iframe_Window');

        if (liveChat) {
            liveChat.style.display = isOpen ? 'none' : '';
        }
    }

    const collapsible = offersCollapsible(dropdown, onCollapsibleToggled);

    const close = () => {
        collapsible.close();
    }

    const collapsibleAccordions = [...accordions].map(acc => accordionCollapsible(acc, null));

    const closeAccordions = () => {
        collapsibleAccordions.close();
    }

    const updateCount = (filterValues) => {
        for (var i = 0; i < filters.length; i++) {
            const filter = filters[i];
            const checkbox = filter.getElementsByClassName('checkbox__input')[0];
            const count = filter.getElementsByClassName('filter-count')[0];
            const label = filter.getElementsByTagName('label')[0];

            if (!checkbox || !count || !label) { continue; }

            const filterValue = filterValues.values.find((v) => v.value === checkbox.getAttribute('key'));

            if (!filterValue) { continue; }

            count.innerHTML = `(${filterValue.count})`;
            label.classList.remove('checkbox--disabled');
            checkbox.removeAttribute('disabled');

            if (filterValue.count === 0) {
                label.classList.add('checkbox--disabled');
                checkbox.setAttribute('disabled', true);
            }
        }
    };

    const init = () => {
        setStickyHeight();
        window.addEventListener('scroll', scroll);
        window.addEventListener('resize', setStickyHeight);
        [...filterCheckboxes].map(filterCheckbox => filterCheckbox.addEventListener('click', onFilterTicked));
        showResultsButton.addEventListener('click', showResults);
    };

    init();

    return {
        elem: dropdown,
        close,
        closeAccordions,
        checkboxes: filterCheckboxes,
        updateCount
    };

}